import { RegionShared } from "@1games-ru/region-shared";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import formatPrice from "@/core/helpers/formatPrice";
import { BankCardIcon, ChevronsUpIcon, RubleIcon } from "@/shared/icons";
import { Modal, SoundButton } from "@/shared/ui";
import { type ModalProps } from "@/shared/ui/modal/Modal";

type Props = {
  level: number;
  onBuy: () => void;
  pending?: boolean;
  improve?: (typeof RegionShared.Cef.Requests.InventorySafeOpenRequest)["improvement"];
} & ModalProps;

export default function InventorySafeUpgradeLevelModal({
  level,
  onClose,
  onBuy,
  pending,
  improve,
  ...props
}: Props) {
  if (!improve) return null;

  return (
    <Modal
      className="w-[26.375rem]"
      style={{ boxShadow: "0px 0px 200px 0px rgba(33, 101, 44, 0.60)" }}
      classNameOverlay="z-[99999]"
      onClose={onClose}
      {...props}
    >
      <div className={cn("flex flex-col items-center justify-center shrink-0 w-full")}>
        <div className="text-18 font-bold">
          Купить улучшения уровень {improve.nextValue}?
        </div>

        <div className="flex items-center gap-2.5 mt-1">
          <ChevronsUpIcon size={12} className="text-white/50" />
          <div className="text-14 font-medium text-white/30">
            Текущий уровень улучшения сейфа:
            <span className="ml-2 text-14 font-bold text-[#84FF97]">{level}</span>
          </div>
        </div>

        <div className="my-5 flex justify-center relative h-[1px] w-full bg-[#191919]">
          <div className="h-full w-[33%] bg-[#84FF97]" />
        </div>

        <div
          className={clsx(
            "w-full h-[2.75rem]",
            "flex items-center justify-center gap-2 bg-gradient-to-r from-[#368D44]/10 to-[#21652C]/10",
            "rounded-[0.5rem] border border-dashed border-[#368D44]",
            "text-16 font-bold"
          )}
        >
          <RubleIcon size={20} className="text-[#84FF97]" />
          {formatPrice(improve.amount)} ₽
        </div>

        <div className="w-full text-center text-15 text-white/60 mt-2.5 px-5">
          После покупки вам будет доступна новая ячейка в сейфе для хранения
        </div>

        <div className="w-full grid grid-cols-2 gap-2 mt-5" data-mz-accent="success">
          <SoundButton
            className="h-[2.75rem] flex items-center gap-2.5 text-12 font-bold"
            onClick={onBuy}
            loading={pending}
            disabled={pending}
          >
            <BankCardIcon size={20} className="text-white" />
            Купить
          </SoundButton>

          <SoundButton
            className="h-[2.75rem] text-12 font-bold"
            variant="solid-surface-gradient"
            onClick={onClose}
            disabled={pending}
          >
            Отмена
          </SoundButton>
        </div>
      </div>
    </Modal>
  );
}
